<template>
  <el-container class="outer">
    <div>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-card>
            <el-row>
              <el-col :span="22">
                <div class="title">{{$t("CONTACTO_contacto")}}</div>
              </el-col>
              <el-col :span="2" style="text-align:right !important;">
                <div class="closeIcon" @click="onClose">
                  <el-icon><Close /></el-icon>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <div class="subTitle">{{$t('GENERAL_infoColven')}}</div>
            </el-row>
            <el-row>
              <div class="descripcion">
                Ruta 11 Km 814 – (S3574XAB) Guadalupe Norte – Santa Fe - Argentina
                <br />Tel.: (++54-3482) 49-8800
                <br />
                <span class="link">colven@colven.com.ar</span>
              </div>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </el-container>
</template>

<script>
export default {
  name: "InformacionContacto",
  methods: {
    onClose() {
      this.$router.push({ name: "Login" });
    }
  }
};
</script>

<style scoped>
.el-container.outer {
  display: table;
  position: absolute;
  top: 50px;
  left: 0;
  height: 100%;
  width: 100%;
}

.contactContainer {
  display: flex;
  vertical-align: middle;
}

.el-card {
  margin-left: auto;
  margin-right: auto;
  width: 80%;
  max-width: 690px !important;
  text-align: left;
}

.closeIcon {
  font-size: 32px;
  cursor: pointer;
}

.title {
  font-size: 35px;
  font-weight: bold;
  color: var(--main-color);
}
.subTitle {
  font-size: 20px;
  font-weight: bold;
  color: #787878;
  margin-top: 25px;
}
.descripcion {
  font-size: 20px;
  font-weight: normal;
  color: #b0b0b0;
  line-height: 150%;
}
.link {
  color: #5aabc6;
}
@media (max-width: 768px) {
  .el-card {
  margin-top: 50px;
  margin-left: 5%;
  max-width: 80% !important;
  padding: 10px 20px !important;

}
}
</style>
